var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.34544 18.0001H15.6543C16.8472 18.0001 17.8179 17.0295 17.8179 15.8364V3.98007C17.8179 2.78711 16.8474 1.81641 15.6543 1.81641H15.6439V2.84922C15.6439 3.59342 15.0387 4.19864 14.2945 4.19864H14.1353C13.3911 4.19864 12.7859 3.59344 12.7859 2.84922V1.81661H5.21374V2.84942C5.21374 3.59362 4.60854 4.19884 3.86432 4.19884H3.70514C2.96112 4.19884 2.35572 3.59364 2.35572 2.84942V1.81661H2.34531C1.15234 1.81661 0.181641 2.78717 0.181641 3.98027V15.8364C0.181901 17.0295 1.15247 18.0001 2.34547 18.0001L2.34544 18.0001ZM1.42467 6.58807H16.575V15.8362C16.575 16.3441 16.162 16.757 15.6542 16.757L2.3454 16.7571C1.83759 16.7571 1.42464 16.3441 1.42464 15.8363L1.42467 6.58807Z",
    fill: "#00754A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.87793 7.78125H5.47176V9.85625H2.87793V7.78125Z",
    fill: "#00754A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.09473 7.78125H8.68856V9.85625H6.09473V7.78125Z",
    fill: "#00754A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.31152 7.78125H11.9054V9.85625H9.31152V7.78125Z",
    fill: "#00754A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5273 7.78125H15.1212V9.85625H12.5273V7.78125Z",
    fill: "#00754A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.87793 10.479H5.47176V12.554H2.87793V10.479Z",
    fill: "#00754A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.09473 10.479H8.68856V12.554H6.09473V10.479Z",
    fill: "#00754A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.31152 10.479H11.9054V12.554H9.31152V10.479Z",
    fill: "#00754A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5273 10.479H15.1212V12.554H12.5273V10.479Z",
    fill: "#00754A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M2.87793 13.1768H5.47176V15.2518H2.87793V13.1768Z",
    fill: "#00754A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M6.09473 13.1768H8.68856V15.2518H6.09473V13.1768Z",
    fill: "#00754A"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M9.31152 13.1768H11.9054V15.2518H9.31152V13.1768Z",
    fill: "#00754A"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5273 13.1768H15.1212V15.2518H12.5273V13.1768Z",
    fill: "#00754A"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M3.70535 3.61927H3.86453C4.28894 3.61927 4.63433 3.27388 4.63433 2.84947V0.7698C4.63452 0.345383 4.28894 0 3.86453 0H3.70535C3.28093 0 2.93555 0.345383 2.93555 0.7698V2.84947C2.93574 3.27388 3.28093 3.61927 3.70535 3.61927Z",
    fill: "#00754A"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M14.135 3.61927H14.2942C14.7186 3.61927 15.064 3.27388 15.064 2.84947V0.7698C15.064 0.345383 14.7186 0 14.2942 0H14.135C13.7106 0 13.3652 0.345383 13.3652 0.7698V2.84947C13.3652 3.27388 13.7106 3.61927 14.135 3.61927Z",
    fill: "#00754A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.54d12659d09e228030962e9e15068469.svg";
export { ForwardRef as ReactComponent };